import packageJson from '../../package.json';

export const environment = {
  version: packageJson.version,
  production: false,
  server: 'https://dev.mybus.t1.cloud.technit.solutions/api/v1/',
  mapApi: 'AIzaSyAVtuCtKbhudm_bQNQJjFuek5oiywFrkTs',
  secureKey: Math.random().toString(32).substring(2, 32),
  encryptToken: '',
  iabConfig: {
    location: 'yes',
    hidenavigationbuttons: 'yes',
    toolbarposition: 'bottom',
    toolbarcolor: '#333',
    navigationbuttoncolor: '#ffffff',
    hideurlbar: 'yes',
    closebuttoncaption: 'Cerrar',
  },
  pusher: {
    app_id: '856907',
    key: '58cb750d5672b8a78bfc',
    secret: '93ec299ca7ffb99640d6',
    cluster: 'us3',
    forceTLS: true,
  },
  routesProvider: 'routes',
};
